var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublicLiability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.3,29.2l-0.7,1.9L3.9,34.2c-1.5,0.4-2.4,2-2,3.5c0.4,1.5,2,2.4,3.5,2l13.1-3.5c0.2-0.1,0.5-0.2,0.7-0.3L19.1,34L16.3,29.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.8,
    cy: 4.9,
    r: 4.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3,24.8l-6.7-5.5l-3.5-5.4c0.1-0.9-0.2-1.8-0.9-2.6l-4-4.3c-1.2-1.3-3.3-1.4-4.6-0.2L15.1,18.4l0,0c-0.7,0.7-0.9,1.6-0.8,2.5c0.1,0.6-0.3-0.2,6.8,12.3c-0.1,1.3-0.8,12.3-0.9,13.8c-0.1,1.6,1.1,3,2.8,3l18.5,0c0.5,0,0.9-0.3,1.2-0.7c0.2-0.4,0.3-0.9,0-1.4l-4.3-7.8c-0.2-0.4-0.6-0.6-1-0.7c-0.4-0.1-0.8,0.1-1.2,0.4L34.2,42l-4.7,0.4c-0.2,0-0.5,0.1-0.7,0.3l-2.7,2c0.3-3.8,0.6-9.3,0.8-11.9c0-0.5-0.1-1.1-0.4-1.6L19.6,19l0,0l0,0l6,6.7l2.3-2.2c0-0.2-0.1,0.5,2.4-9.4l-0.2,9.7l0,0c0,0.8,0.4,1.5,1,2l7.9,5.4c1.1,0.7,2.5,0.4,3.3-0.6c0.7-1.1,0.4-2.5-0.6-3.3L35,22.8l0.1-8.9l1.9,7.5l6,4.1c1.2,0.8,1.9,2,2,3.4c0.9,0.3,2,0.1,2.6-0.7C48.5,27.1,48.3,25.6,47.3,24.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicLiability);
export default __webpack_public_path__ + "static/media/public-liability.78c0fdce981d17d44f958338383d8bbd.svg";
export { ForwardRef as ReactComponent };